import { useEffect, useState } from "react";
import { Box, Dialog, TextField, Button, DialogTitle, DialogContent, DialogActions, Typography, Backdrop, CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import QuestionService from "../../../../services/questionsService";
import useAlert from "../../../../hooks/useAlert";
import { useSelector } from "react-redux";
import marketplacesService from "../../../../services/marketplacesService";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";

const AnswerQuestion = ({ open, onClose, question }) => {
  const [answerText, setAnswerText] = useState("");
  const { showSuccessAlertAll, showErrorAlertAll } = useAlert();
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
  const userId = useSelector((state) => state?.auth?.user?.id);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      setLoading(true);
      var selectedPleace = question.ecommercePlace != null ? question.ecommercePlace.name : question.marketPlace.name;
      var body = createRequestBody(selectedPleace);
      await QuestionService.answerQuestion(body, selectedPleace);
      setLoading(false);
      showSuccessAlertAll();
      onClose();
    } catch (exx) {
      setLoading(false);
      showErrorAlertAll();
    }
  };

  const createRequestBody = (selectedPlaceName) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter(account => account.marketPlaceName === selectedPlaceName)
      .map(account => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter(account => account.ecommercePlaceName === selectedPlaceName)
      .map(account => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: userId,
      orderQuestion: question,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSetting: ecommercePlaceSettings,
      answerText: answerText,
      questionId: question.questionId.toString(),
      actionType: answerType,
      description:description
    };
  };

  useEffect(() => {
    const fetchAccounts = async () => {

      try {
        const response = await marketplacesService.getMarketPlacesAccountsApi(
          userId,

        );
        setMarketpleacesAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
        );

      }

    };
    const fetchAccountsEcommerce = async () => {

      try {
        const response = await ecommercePlaceService.getEcommercePlaceAccountsApi(
          userId,

        );
        setEcommerceAllAccounts(response?.data?.data?.data);

      } catch (err) {
        setError(
          err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
        );

      }

    };
    fetchAccounts();
    fetchAccountsEcommerce();
  }, [userId]);

  const [answerType, setAnswerType] = useState(null);
  const [description, setDescription] = useState(null);

  const handleChange = (event) => {
    setDescription(null);
    setAnswerType(event.target.value);
  };
  const placeName = question?.ecommercePlace != null ? question?.ecommercePlace?.name : question?.marketPlace?.name;
  useEffect(() => {
    setAnswerType(null);
    setDescription(null);
    setAnswerText("");
  }, [open])
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
        },
        initial: { y: 20, opacity: 0 },
        animate: { y: 0, opacity: 1 },
        transition: { duration: 0.3 },
      }}
    >
      <Box
        sx={{
          padding: 4,
          background: 'linear-gradient(135deg, #F6F8FD 0%, #F1F4F9 100%)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box
            sx={{
              width: 5,
              height: 28,
              background: 'linear-gradient(180deg, #2196F3 0%, #1976D2 100%)',
              borderRadius: '4px',
              mr: 2,
            }}
          />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              background: 'linear-gradient(90deg, #1976D2 0%, #2196F3 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '0.5px',
            }}
          >
            Cevapla
          </Typography>
        </Box>

        <DialogContent sx={{
          p: 0,
          maxHeight: '60vh',
          overflowY: 'auto'
        }}>
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: 'text.secondary',
              bgcolor: 'rgba(33, 150, 243, 0.08)',
              p: 2,
              borderRadius: 2
            }}
          >
            <strong>Soru: </strong>{question?.questionText}
          </Typography>

          <TextField
            autoFocus
            fullWidth
            label="Cevabınız"
            multiline
            rows={5}
            value={answerText}
            onChange={(e) => setAnswerText(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#fff',
                '&:hover fieldset': {
                  borderColor: '#2196F3',
                },
              },
              mb: 4,
            }}
          />

          {placeName == "Ciceksepeti" ?
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-simple-select-label">Cevap Tipi</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={answerType}
                label="Age"
                onChange={handleChange}
              >
                <MenuItem value={1}>Soru ve cevabı yayınla</MenuItem>
                <MenuItem value={2}>Cevabı Sadece Müşteriye Gönder</MenuItem>
                <MenuItem value={3}>Uygunsuz İçerik</MenuItem>
                <MenuItem value={4}>Başka Satıcıya Ait Soru</MenuItem>
              </Select>
            </FormControl> : null}

          {
            answerType == 3 ?
              <TextField
                autoFocus
                fullWidth
                label="Açıklama"
                multiline
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    bgcolor: '#fff',
                    '&:hover fieldset': {
                      borderColor: '#2196F3',
                    },
                  },
                  mb: 4,
                }}
              /> : null
          }
        </DialogContent>

        <DialogActions sx={{ p: 2, bgcolor: 'background.paper' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: 2,
              px: 3,
              color: 'text.secondary',
              borderColor: 'divider',
              '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'rgba(33, 150, 243, 0.08)',
              },
            }}
          >
            İptal
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!answerText.trim() || (placeName == "Ciceksepeti" ? answerType == null : false) || (answerType == 3 ? description == null : false)}
            sx={{
              borderRadius: 2,
              px: 3,
              bgcolor: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
              '&:disabled': {
                bgcolor: 'action.disabledBackground',
              },
            }}
          >
            Cevapla
          </Button>
        </DialogActions>
      </Box>

      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backdropFilter: 'blur(1px)',
        }}
        open={loading}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    </Dialog>
  );
};

export default AnswerQuestion;